import { render, staticRenderFns } from "./SGT.vue?vue&type=template&id=449a0a92&scoped=true&"
import script from "./SGT.vue?vue&type=script&lang=js&"
export * from "./SGT.vue?vue&type=script&lang=js&"
import style0 from "./SGT.vue?vue&type=style&index=0&id=449a0a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a0a92",
  null
  
)

export default component.exports